import ReleaseNotesAPI from '../../api/releaseNotes';

const releaseNoteTypes = {
  SET_RELEASE_NOTES: 'SET_RELEASE_NOTES',
  SET_TODAY_NOTE: 'SET_TODAY_NOTE',
  SET_UI_FLAG: 'SET_RELEASE_NOTES_UI_FLAG',
};

const state = {
  records: [],
  todayNote: null,
  uiFlags: {
    isFetching: false,
    isFetchingToday: false,
  },
};

const getters = {
  allNotes: $state => $state.records,
  todayNote: $state => $state.todayNote,
  uiFlags: $state => $state.uiFlags,
};

const actions = {
  fetchAll: async ({ commit }) => {
    commit(releaseNoteTypes.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await ReleaseNotesAPI.get();
      commit(releaseNoteTypes.SET_RELEASE_NOTES, response.data);
      return response.data;
    } catch (error) {
      // Silencioso — notas de atualização não devem quebrar o app
      return [];
    } finally {
      commit(releaseNoteTypes.SET_UI_FLAG, { isFetching: false });
    }
  },

  fetchToday: async ({ commit }) => {
    commit(releaseNoteTypes.SET_UI_FLAG, { isFetchingToday: true });
    try {
      const response = await ReleaseNotesAPI.getToday();
      // A API devolve `null` quando não há nota publicada para hoje.
      const note = response.data || null;
      commit(releaseNoteTypes.SET_TODAY_NOTE, note);
      return note;
    } catch (error) {
      commit(releaseNoteTypes.SET_TODAY_NOTE, null);
      return null;
    } finally {
      commit(releaseNoteTypes.SET_UI_FLAG, { isFetchingToday: false });
    }
  },
};

const mutations = {
  [releaseNoteTypes.SET_RELEASE_NOTES]($state, data) {
    $state.records = data;
  },
  [releaseNoteTypes.SET_TODAY_NOTE]($state, data) {
    $state.todayNote = data;
  },
  [releaseNoteTypes.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
